export type InvalidShapeReason = 'minimum-points' | 'collision'

export const INVALID_SHAPE_KEYS = {
  MINIMUM_POINTS: 'minimum-points',
  COLLISION: 'collision',
} as const
